var _ref2, _ref3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 262,
    height: 111.558,
    viewBox: "0 0 262 111.558",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip-path"
  }, React.createElement("rect", {
    id: "Rectangle_1574",
    "data-name": "Rectangle 1574",
    width: 262,
    height: 111.558,
    fill: "none"
  })))), _ref3 || (_ref3 = React.createElement("g", {
    id: "logo",
    transform: "translate(0 0)"
  }, React.createElement("path", {
    id: "Path_3532",
    "data-name": "Path 3532",
    d: "M30.814,14.226,22.35,59.2,13.543,14.226H0v62.7H9.415V37.656l9.149,39.272h7.6l8.257-39.409V76.927H43.84v-62.7Z",
    transform: "translate(0 10.189)",
    fill: "#2e2e2d"
  }), React.createElement("path", {
    id: "Path_3533",
    "data-name": "Path 3533",
    d: "M29.309,14.226h9.413l7.016,22.542,7-22.542h9.415L50.438,47.911V76.927H41.025V47.911Z",
    transform: "translate(20.991 10.188)",
    fill: "#2e2e2d"
  }), React.createElement("path", {
    id: "Path_3534",
    "data-name": "Path 3534",
    d: "M65.1,76.9V14.265h9.413V40.859H85.849V14.265h9.413V76.9H85.849V50.271H74.511V76.9Z",
    transform: "translate(46.623 10.216)",
    fill: "#2e2e2d"
  }), React.createElement("path", {
    id: "Path_3535",
    "data-name": "Path 3535",
    d: "M107.679,76.927v-62.7h13.544L130.029,59.2l8.464-44.973h13.026v62.7h-9.413V37.518l-8.258,39.409h-7.6l-9.151-39.272V76.927Z",
    transform: "translate(77.12 10.188)",
    fill: "#2e2e2d"
  }), React.createElement("path", {
    id: "Path_3536",
    "data-name": "Path 3536",
    d: "M136.988,14.226v62.7h26.9V67.512H146.4V50.232h12.815V40.815H146.4V23.638h17.486V14.226Z",
    transform: "translate(98.111 10.189)",
    fill: "#2e2e2d"
  }), React.createElement("rect", {
    id: "Rectangle_1573",
    "data-name": "Rectangle 1573",
    width: 6.758,
    height: 111.558,
    transform: "translate(92.304 0)",
    fill: "#449b23"
  }), React.createElement("g", {
    id: "Group_4596",
    "data-name": "Group 4596",
    transform: "translate(0 0)"
  }, React.createElement("g", {
    id: "Group_4595",
    "data-name": "Group 4595",
    clipPath: "url(#clip-path)"
  }, React.createElement("path", {
    id: "Path_3537",
    "data-name": "Path 3537",
    d: "M116.113,28.806a15.031,15.031,0,0,0-4.3-10.618,13.689,13.689,0,0,0-10.256-4.363,14.8,14.8,0,0,0-10.606,4.363A14.151,14.151,0,0,0,86.5,28.806V62.991A14.449,14.449,0,0,0,88.536,70.5a12.865,12.865,0,0,1,6.764-9.93V27.337a.864.864,0,0,1,.251-.608L100.7,21.58a.861.861,0,0,1,1.215,0l5.149,5.149a.861.861,0,0,1,0,1.215l-.4.395-.263.263-2.168,2.168,2.464,2.463.362.362a.861.861,0,0,1,0,1.215l-.362.36-2.464,2.464L106.7,40.1l.362.362a.858.858,0,0,1,0,1.208l-.362.362-2.464,2.463,2.464,2.463.362.362a.861.861,0,0,1,0,1.215l-.362.362-2.464,2.463,2.464,2.463.362.362a.864.864,0,0,1,.251.608v5.778a12.866,12.866,0,0,1,6.776,10.127,14.825,14.825,0,0,0,2.025-7.7Z",
    transform: "translate(61.949 9.901)",
    fill: "#2e2e2d"
  }), React.createElement("path", {
    id: "Path_3538",
    "data-name": "Path 3538",
    d: "M100.575,53.695a4.241,4.241,0,0,0,.632-2.21,4.29,4.29,0,1,0-8.581,0,4.24,4.24,0,0,0,.58,2.116,15.687,15.687,0,0,0,3.968.506,14.367,14.367,0,0,0,3.4-.412",
    transform: "translate(66.339 33.8)",
    fill: "#2e2e2d"
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.bfd0d9b7.svg";
export { ForwardRef as ReactComponent };